import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const OtherCertifiedIncomeContainer = styled.div`
  padding: 0 60px;
`;

export const OtherCertifiedIncomeHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OtherCertifiedIncomeHeaderInfo = styled.h5`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 20px;
`;

export const OtherCertifiedIncomeContent = styled.div``;
